/**
 * Heuristics for grid defaults (column visibility, etc.) based on current data.
 */

function isEmptyValue(value) {
  if (value === null || value === undefined) return true
  if (Array.isArray(value)) return value.length === 0
  if (typeof value === 'string') return value.trim() === ''
  return false
}

/**
 * Returns a map of columnId -> visible boolean.
 *
 * We auto-hide columns that are mostly empty to reduce noise,
 * but always keep core columns visible.
 */
export function getSmartProjectColumnVisibility(rows, {
  alwaysShow = ['id', 'topic', 'status', 'due_date'],
  defaultHidden = ['details', 'notes'],
  mostlyEmptyThreshold = 0.8,
} = {}) {
  const data = Array.isArray(rows) ? rows : []
  const visibility = {}

  for (const col of defaultHidden) {
    visibility[col] = false
  }

  if (data.length === 0) {
    for (const col of alwaysShow) visibility[col] = true
    return visibility
  }

  const sampleCols = new Set()
  for (const row of data) {
    Object.keys(row || {}).forEach(k => sampleCols.add(k))
  }

  for (const col of sampleCols) {
    if (alwaysShow.includes(col)) {
      visibility[col] = true
      continue
    }

    // don't override explicit defaultHidden
    if (Object.prototype.hasOwnProperty.call(visibility, col)) continue

    let empty = 0
    for (const row of data) {
      if (isEmptyValue(row?.[col])) empty++
    }

    const emptyRatio = empty / data.length
    if (emptyRatio >= mostlyEmptyThreshold) {
      visibility[col] = false
    }
  }

  // alwaysShow wins
  for (const col of alwaysShow) visibility[col] = true

  return visibility
}
